import React, { createContext, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import LeadModal from './components/LeadModal';
import Home from './pages/Home';
import TrademarkRegistration from './pages/TrademarkRegistration';
import CopyrightRegistration from './pages/CopyrightRegistration';
import CompanyFormation from './pages/CompanyFormation';
import TrademarkSearch from './pages/TrademarkSearch';
import AmazonBrandRegistry from './pages/AmazonBrandRegistry';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';

// Create context for modal
export const ModalContext = createContext();

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalButtonText, setModalButtonText] = useState('');

  const openModal = (buttonText = '') => {
    setModalButtonText(buttonText);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalButtonText('');
  };

  return (
    <ModalContext.Provider value={{ openModal, closeModal }}>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/trademark-registration" element={<TrademarkRegistration />} />
              <Route path="/copyright-registration" element={<CopyrightRegistration />} />
              <Route path="/company-formation" element={<CompanyFormation />} />
              <Route path="/trademark-search" element={<TrademarkSearch />} />
              <Route path="/amazon-brand-registry" element={<AmazonBrandRegistry />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-conditions" element={<TermsConditions />} />
            </Routes>
          </main>
          <Footer />
          <LeadModal 
            isOpen={isModalOpen} 
            onClose={closeModal}
            buttonText={modalButtonText}
          />
        </div>
      </BrowserRouter>
    </ModalContext.Provider>
  );
}

export default App;